webpackJsonp([35783957827783],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _profile = __webpack_require__(56);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    var title = 'Mathias Schilling - Just another paper cut survivor and software engineer';
	    var description = 'I create business impact through code and help organisations become more effective in delivering solutions to their customer\'s problems.';
	
	    var meta = [{ name: 'description', content: description }, { name: 'og:image', content: _profile2.default }, { name: 'og:title', content: title }, { name: 'og:description', description: description }, { name: 'twitter:site', content: '@matchilling' }, { name: 'twitter:creator', content: '@matchilling' }, { name: 'twitter:description', content: description }, { name: 'twitter:image', content: _profile2.default }];
	
	    return _react2.default.createElement(_reactHelmet2.default, { title: title, meta: meta });
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-68c5e978e0d4f728ef44.js